<template>
  <div class="status px-4" id="sDownload">
    <div class="page-title pt-4">
      <v-row>
        <v-col cols="12" md="6">
          <h6 class="font-weight-bold text-h5">
            Asset Command <span class="font-weight-medium"> - Status</span>
            <v-icon
              color="rgb(0, 102, 124)"
              class="download-icon"
              @click="exportPDF('sDownload', 'statusDownload')"
              >mdi-download-box</v-icon
            >
          </h6>
        </v-col>
        <v-col md="2"> </v-col>
        <v-col cols="12" md="2" class="bg-white">
          <v-select
            class="ambt-select"
            :items="homeLocations"
            label="Select Asset Owner"
            width="180px"
            :value="selectedHomeLocation"
            dense
            outlined
            float-right
            :menu-props="{ offsetY: true, contentClass: 'ambt-select' }"
            @change="updateSelectedHomeLocation($event)"
            :disabled="
              getUserData
                ? !(getUserData.organization.attributes.find(item=> item.name == 'homeLocation').value == 'TLO')
                : false
            "
          ></v-select>
        </v-col>
        <v-col cols="12" md="2" class="bg-white">
          <v-select
            :items="locations"
            label="Select Asset Location"
            width="180px"
            :value="selectedLocation"
            dense
            outlined
            float-right
            :menu-props="{ offsetY: true, contentClass: 'ambt-select' }"
            @change="updateSelectedLocation($event)"
          ></v-select>
        </v-col>
      </v-row>
    </div>
    <v-row>
      <v-col cols="12" md="3" class="bg-white">
        <v-skeleton-loader :loading="graphLoading" class="bar-graph" type="card"
          ><v-row class="graph-header">
            <v-col cols="4" class="text-right">
              <v-icon>mdi-check</v-icon>
              <p class="text-right" style="position: relative; right: -1px">
                Active
              </p>
            </v-col>
            <v-col cols="3"></v-col>
            <v-col cols="5" class="text-center">
              <h1>
                {{
                  statusGraphData.find((element) => element.status == "ACTIVE")
                    ? sum(
                        statusGraphData.find(
                          (element) => element.status == "ACTIVE"
                        ).list,
                        "count"
                      )
                    : 0
                }}
              </h1>
            </v-col>
          </v-row>
          <BarChart
            bid="activeChart"
            :data="
              statusGraphData.find((element) => element.status == 'ACTIVE')
            "
          />
        </v-skeleton-loader>
      </v-col>
      <v-col cols="12" md="3" class="bg-white">
        <v-skeleton-loader :loading="graphLoading" class="bar-graph" type="card"
          ><v-row class="graph-header">
            <v-col cols="4" class="text-right">
              <v-icon>mdi-timer-sand</v-icon>
              <p class="text-right" style="position: relative; right: 1px">
                Dwell
              </p>
            </v-col>
            <v-col cols="3"></v-col>
            <v-col cols="5" class="text-center">
              <h1 style="color: #ff3700">
                {{
                  statusGraphData.find((element) => element.status == "DWELL")
                    ? sum(
                        statusGraphData.find(
                          (element) => element.status == "DWELL"
                        ).list,
                        "count"
                      )
                    : 0
                }}
              </h1>
            </v-col>
          </v-row>
          <BarChart
            bid="dwellChart"
            :data="statusGraphData.find((element) => element.status == 'DWELL')"
          />
        </v-skeleton-loader>
      </v-col>
      <v-col cols="12" md="3" class="bg-white">
        <v-skeleton-loader :loading="graphLoading" class="bar-graph" type="card"
          ><v-row class="graph-header">
            <v-col cols="4" class="text-right">
              <v-icon>mdi-truck-outline</v-icon>
              <p class="text-right" style="position: relative; right: -3px">
                Transit
              </p>
            </v-col>
            <v-col cols="3"></v-col>
            <v-col cols="5" class="text-center">
              <h1 style="color: #ff3700">
                {{
                  statusGraphData.find((element) => element.status == "TRANSIT")
                    ? sum(
                        statusGraphData.find(
                          (element) => element.status == "TRANSIT"
                        ).list,
                        "count"
                      )
                    : 0
                }}
              </h1>
            </v-col>
          </v-row>
          <BarChart
            bid="transitChart"
            :data="
              statusGraphData.find((element) => element.status == 'TRANSIT')
            "
          />
        </v-skeleton-loader>
      </v-col>
      <v-col cols="12" md="3" class="bg-white">
        <v-skeleton-loader :loading="graphLoading" class="bar-graph" type="card"
          ><v-row class="graph-header">
            <v-col cols="4" class="text-right">
              <v-icon>mdi-help</v-icon>
              <p class="text-right" style="position: relative; right: 4px">
                Lost
              </p>
            </v-col>
            <v-col cols="3"></v-col>
            <v-col cols="5" class="text-center">
              <h1 style="color: #ff3700">
                {{
                  statusGraphData.find((element) => element.status == "LOST")
                    ? sum(
                        statusGraphData.find(
                          (element) => element.status == "LOST"
                        ).list,
                        "count"
                      )
                    : 0
                }}
              </h1>
            </v-col>
          </v-row>
          <BarChart
            bid="lostChart"
            :data="statusGraphData.find((element) => element.status == 'LOST')"
          />
        </v-skeleton-loader>
      </v-col>
      <v-col cols="12" md="6">
        {{palletStr}}
      </v-col>
      <v-col cols="12">
        <v-skeleton-loader :loading="loading" type="image">
        <v-data-table
          :headers="headers"
          :loading="loading"
          :items="statusDetails"
          :items-per-page="items_per_page_status"
          class="elevation-1 text-center"
          :hide-default-footer="true"
        >
          <template v-slot:[`item.status`]="{ item }">
            <span @click="filterAssetHistory(item.asset_id)" class="cursor">
              {{ item.status }}
            </span>
          </template>
          <template v-slot:[`item.internal_status`]="{ item }">
              <span @click="filterAssetHistory(item.asset_id)" class="cursor">
                {{ item.internal_status ? item.internal_status : "-" }}
            </span>
          </template>
          <template v-slot:[`item.location`]="{ item }">
            <span @click="filterAssetHistory(item.asset_id)" class="cursor">
              {{ item.location }}
            </span>
          </template>
          <template v-slot:[`item.device_id`]="{ item }">
            <span @click="filterAssetHistory(item.asset_id)" class="cursor">
              {{ item.device_id }}
            </span>
          </template>
          <template v-slot:[`item.asset_type`]="{ item }">
            <span @click="filterAssetHistory(item.asset_id)" class="cursor">
              {{ item.asset_type }}
            </span>
          </template>
          <template v-slot:[`item.BATTERY_VOLTAGE`]="{ item }">
            <span @click="filterAssetHistory(item.asset_id)" class="cursor">
              {{
                item.BATTERY_VOLTAGE ? item.BATTERY_VOLTAGE / 1000 + " v" : ""
              }}
            </span>
          </template>
          <template v-slot:[`item.status_date`]="{ item }">
            <span @click="filterAssetHistory(item.asset_id)" class="cursor">
              {{
                (parseFloat(item.status_date) * 1000)
                  | formatDateTime(getUserData.user.timezone)
              }}
            </span>
          </template>
          <template v-slot:[`header.asset_id`]="{ header }">
        {{ header.text }}
        <v-menu
          offset-y
          :close-on-content-click="false"
          v-model="showmenu"
          content-class="elevation-1 bg-white"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon small> mdi-menu </v-icon
              ><span
                class="filterSelected"
                v-if="
                  selectedStatusAssetID != '' && selectedStatusAssetID != null
                "
              ></span>
            </v-btn>
          </template>
          <div
            style="background-color: #f5f5f5; width: 200px; height: 110px"
            class="px-3 pt-4 text-search"
          >
            <v-text-field
              label="Asset ID"
              placeholder="Type Here"
              v-model="selectedStatusAssetID"
              @click:clear="clearAssetId()"
              outlined
              clearable
              dense
            ></v-text-field>
            <v-btn
              depressed
              class="float-right my-2 white--text font-weight-bold"
              small
              color="rgb(0, 102, 124)"
              :disabled="
                selectedStatusAssetID === '' || selectedStatusAssetID === null
                  ? true
                  : false
              "
              @click="updateSelectedAssetID()"
            >
              Apply
            </v-btn>
          </div>
        </v-menu>
      </template>
      <template v-slot:[`header.device_id`]="{ header }">
        {{ header.text }}
        <v-menu
          offset-y
          :close-on-content-click="false"
          v-model="showbeacon"
          content-class="elevation-1 bg-white"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon small> mdi-menu </v-icon>
              <span
                class="filterSelected"
                v-if="
                  selectedStatusDeviceID != '' &&
                  selectedStatusDeviceID != null
                "
              ></span>
            </v-btn>
          </template>
          <div
            style="background-color: #f5f5f5; width: 200px; height: 110px"
            class="px-3 pt-4 text-search"
          >
            <v-text-field
              label="Beacon ID"
              placeholder="Type Here"
              v-model="selectedStatusDeviceID"
              @click:clear="clearBeaconId()"
              outlined
              clearable
              dense
            ></v-text-field>
            <v-btn
              depressed
              class="float-right my-2 white--text font-weight-bold"
              small
              color="rgb(0, 102, 124)"
              :disabled="
                selectedStatusDeviceID === '' ||
                selectedStatusDeviceID === null
                  ? true
                  : false
              "
              @click="updateSelectedDeviceID()"
            >
              Apply
            </v-btn>
          </div>
        </v-menu>
      </template>
          <template v-slot:[`item.asset_id`]="{ item }">
            <span @click="filterAssetHistory(item.asset_id)" class="cursor">{{
              item.asset_id
            }}</span>
          </template>
          <template v-slot:[`header.status`]="{ header }">
            {{ header.text }}
            <v-menu
              offset-y
              :close-on-content-click="false"
              v-model="showCheck"
              content-class="elevation-1"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon small> mdi-menu </v-icon
                  ><span
                    class="filterSelected"
                    v-if="isCheckAll != true && selctedStatus.length != 0"
                  ></span>
                </v-btn>
              </template>
              <div
                style="background-color: #f5f5f5; width: 200px"
                class="px-3 pb-1 pt-2 label-font"
              >
                <v-simple-checkbox
                  @click="checkAll()"
                  v-bind="isCheckAll"
                  :value="isCheckAll"
                  color="black"
                  class="mb-3"
                ></v-simple-checkbox
                ><span class="all-label">Check All</span>
                <v-checkbox
                  v-model="selctedStatus"
                  v-for="(item, i) in status"
                  :label="item"
                  :value="item"
                  :key="i"
                  color="black"
                ></v-checkbox>
                <v-btn
                  depressed
                  class="
                    float-right
                    my-2
                    white--text
                    font-weight-bold
                    status-button
                  "
                  small
                  color="rgb(0, 102, 124)"
                  :disabled="selctedStatus.length == 0 ? true : false"
                  @click="selctedStatusApply()"
                >
                  Apply
                </v-btn>
              </div>
            </v-menu>
          </template>
          <template v-slot:[`header.asset_type`]="{ header }">
            {{ header.text }}
            <v-menu
              offset-y
              :close-on-content-click="false"
              v-model="showItem"
              content-class="elevation-1 bg-white"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon small> mdi-menu </v-icon
                  ><span
                    class="filterSelected"
                    v-if="selectedAsset != 'ALL'"
                  ></span>
                </v-btn>
              </template>
              <div
                style="background-color: #f5f5f5; width: 200px"
                class="px-3 pt-4"
              >
                <v-select
                  :items="assets"
                  width="180px"
                  v-model="selectedAsset"
                  label="Select Asset Type"
                  dense
                  outlined
                  float-right
                  :menu-props="{ offsetY: true, contentClass: 'ambt-select' }"
                  @change="hideselectedItems()"
                ></v-select>
              </div>
            </v-menu>
          </template>
          <template v-slot:[`header.internal_status`]="{ header }">
              {{ header.text }}
              <v-menu offset-y :close-on-content-click="false" v-model="showCheckComments"
                content-class="elevation-1">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon small> mdi-menu </v-icon><span class="filterSelected"
                      v-if="isCommentsCheckAll != true && selectedComments.length != 0"></span>
                  </v-btn>
                </template>
                <div style="background-color: #f5f5f5; width: 200px" class="px-3 pb-1 pt-2 label-font">
                  <v-simple-checkbox @click="checkAllComments()" v-bind="isCommentsCheckAll" :value="isCommentsCheckAll" color="black"
                    class="mb-3"></v-simple-checkbox><span class="all-label">Check All</span>
                  <v-checkbox v-model="selectedComments" v-for="(item, i) in commentList" :label="item"
                    :value="item" :key="i" color="black"></v-checkbox>
                  <v-btn depressed class="
                    float-right
                    my-2
                    white--text
                    font-weight-bold
                    status-button
                  " small color="rgb(0, 102, 124)" :disabled="selectedComments.length == 0 ? true : false"
                    @click="selctedStatusApply()">
                    Apply
                  </v-btn>
              </div>
            </v-menu>
          </template>
        </v-data-table>
        </v-skeleton-loader>
      </v-col>
    </v-row>
    <v-row class="mx-1">
      <v-col class="d-block mx-0 px-0 mt-5">
        <v-select
          :items="pages"
          width="80px"
          :value="items_per_page_status"
          dense
          outlined
          class="float-left wd-80"
          :menu-props="{ offsetY: true, contentClass: 'ambt-select' }"
          @change="updatePerPageItems($event)"
        ></v-select>
        <v-pagination
          flat
          v-model="destination_page"
          color="rgb(0, 102, 124)"
          :length="
            statusDetails.length > 0
              ? Math.ceil(totalRecords / items_per_page_status)
              : 1
          "
          :total-visible="5"
          class="float-right"
        ></v-pagination>
      </v-col>
    </v-row>
  </div>
</template>
<script>
// eslint-disable-next-line
/* eslint-disable */
import exportPdf from "@/components/mixins/exportPdf.js";
import BarChart from "@/components/core/BarChart";
import Vue from "vue";
export default {
  mixins: [exportPdf],
  components: {
    BarChart,
  },
  data() {
    return {
      destination_page: 1,
      selected_data: [],
      pages: [10, 25, 50, 100],
      showItem: false,
      showCheck: false,
      headers: [
        { text: "Asset", value: "asset_id",sortable: false, align: "center" },
        { text: "Beacon Id", value: "device_id",sortable: false, align: "center" },
        { text: "Type", value: "asset_type", sortable: false, align: "center" },
        {
          text: "Location",
          align: "center",
          value: "location",
        },
        { text: "Status", value: "status", sortable: false, align: "center" },
        { text: "Battery Voltage", value: "BATTERY_VOLTAGE", sortable: false, align: "center" },
        { text: "Date", value: "status_date", align: "center" },
      ],
      palletStr: "Pallet Types: A 30\"x30\", B - 54\"x40\", C - 82.5\"x54\"",
      totalRecords: 1,
      status: ["TRANSIT", "LOST", "DWELL", "ACTIVE"],
      selctedStatus: ["TRANSIT", "LOST", "DWELL", "ACTIVE"],
      isCheckAll: true,
      showCheckComments: false,
      isCommentsCheckAll: true,
      commentList: [],
      selectedComments: []
    };
  },
  computed: {
    loading() {
      return this.$store.getters.getLoading;
    },
    graphLoading() {
      return this.$store.getters.getGraphLoading;
    },
    items_per_page_status() {
      return this.$store.getters.getStatusItemsPerPage;
    },
    statusDetails() {
      return this.$store.getters.getStatusDetails;
    },
    getUserData() {
      return this.$store.getters.getUserInfo;
    },
    locations() {
      return this.$store.getters.getLocations;
    },
    selectedLocation() {
      return this.$store.getters.getSelectedLocation;
    },
    selectedHomeLocation() {
      return this.$store.getters.getSelectedHomeLocation;
    },
    assets() {
      return this.$store.getters.getAssets;
    },
    homeLocations() {
      return this.$store.getters.getHomeLocationList.sort();
    },
    statusGraphData() {
      return this.$store.getters.getStatusGraphData;
    },
    selectedStatusAssetID: {
            get() {
              return this.$store.getters.getSelectedStatusAssetID
            },
            set(value) {
                this.$store.commit("SET_SELECTED_STATUS_ASSET_ID", value)
            }            
        },
    selectedStatusDeviceID: {
        get() {
          return this.$store.getters.getSelectedStatusDeviceID
        },
        set(value) {
            this.$store.commit("SET_SELECTED_STATUS_DEVICE_ID", value)
        }            
    },
    selectedAsset: {
        get() {
          return this.$store.getters.getSelectedAssetTypeStatus
        },
        set(value) {
            this.$store.commit("SET_SELECTED_ASSET_TYPE_STATUS", value)
        }            
    },
    internalStatusArr() {
      return this.$store.getters.getInternalStatusList.sort();
    },
  },
  watch: {
    destination_page(val) {
      this.getStatusDetails();
    },
    items_per_page_status(val) {
      if (this.destination_page !== 1) {
        this.destination_page = 1;
      } else {
        this.getStatusDetails();
      }
    },
    statusDetails(val) {
      if (val[0]) {
        this.totalRecords = val[0].count;
      } else {
        this.totalRecords = 0;
      }
    },
    selectedLocation(val) {
      if (this.destination_page !== 1) {
        this.destination_page = 1;
      } else {
        this.getStatusDetails();
      }
      this.getStatusGraphDetails();
    },
    selectedAsset() {
      if (this.destination_page !== 1) {
        this.destination_page = 1;
      } else {
        this.getStatusDetails();
      }
    },
    selectedHomeLocation(val) {
      if (this.destination_page !== 1) {
        this.destination_page = 1;
      } else {
        this.getStatusDetails();
      }
      this.getStatusGraphDetails();
    },
    selctedStatus(val) {
      if (val.length == this.status.length) {
        this.isCheckAll = true;
      } else {
        this.isCheckAll = false;
      }
    },
    selectedComments(val) {
        if (val.length == this.commentList.length) {
          this.isCommentsCheckAll = true;
        } else {
          this.isCommentsCheckAll = false;
        }
      }
  },
  beforeMount() {
    this.getStatusDetails();
    this.getStatusGraphDetails();
    this.commentList = this.internalStatusArr;
    this.selectedComments = this.internalStatusArr;
  },
  mounted() {
    this.isCheckAll = true;
    this.isCommentsCheckAll = true;
  },
  methods: {
    sum(data, prop) {
      var total = 0;
      for (var i = 0, _len = data.length; i < _len; i++) {
        total += parseInt(data[i][prop]);
      }
      return total;
    },
    updatePerPageItems(val) {
      this.$store.dispatch("updateStatusItemsPerPage", val);
    },
    updateSelectedLocation(loc) {
      this.$store.dispatch("updateSelectedLocation", loc);
    },
    getStatusGraphDetails() {
      this.$store.dispatch("getDeviceData", {
        widget: "ASSET_STATUS",
        Location: this.selectedLocation,
        userOrgHomeLocation: this.selectedHomeLocation,
      });
    },
    hideselectedItems() {
      this.showItem = false;
    },
    getStatusDetails() {
      if (this.selctedStatus.length > 0) {
        var statusFilter = "'" + this.selctedStatus.join("','") + "'";
      } else {
        var statusFilter = "ALL";
      }
      if (this.selectedComments.length > 0) {
        var commentsFilter = "'" + this.selectedComments.join("','") + "'";
      } else {
        var commentsFilter = "ALL";
      }
      if (this.destination_page === 1) {
        var page = 0;
      } else {
        var values = this.statusDetails.map((val) => val.index);
        var page = Math.max.apply(null, values);
      }
      const assetID = ( this.selectedStatusAssetID != ''  &&  this.selectedStatusAssetID != null ) ? this.selectedStatusAssetID : 'ALL'
      const deviceID = ( this.selectedStatusDeviceID != '' &&  this.selectedStatusDeviceID != null ) ? this.selectedStatusDeviceID : 'ALL'
      this.$store.dispatch("getDeviceData", {
        widget: "ASSET_DETAILS",
        assetType: this.selectedAsset,
        Status: statusFilter,
        Location: this.selectedLocation,
        pageSize: this.items_per_page_status,
        page: this.destination_page,
        userOrgHomeLocation: this.selectedHomeLocation,
        assetID: assetID,
        deviceID: deviceID,
        internalStatus: commentsFilter,
      });
    },
    filterAssetHistory(asset_id) {
      this.$store.commit("SET_SELECTED_HISTORY_ASSET_ID", asset_id);
      this.$router.push("/history");
    },
    updateSelectedHomeLocation(val) {
      this.$store.commit("SET_SELECTED_HOME_LOCATION", val);
    },
    homeLocation() {
      var me = this;
      return setTimeout(function () {
        var userInfo = JSON.parse(localStorage.getItem("userData"));
        var listLoc = _.flatten(
          userInfo.homeLocations.map((a) => a.attributes)
        ).map((a) => a.value);
        listLoc.unshift("ALL");
        me.homeLocations = listLoc;
      }, 1000);
    },
    selctedStatusApply() {
      if (this.destination_page !== 1) {
        this.destination_page = 1;
      } else {
        this.getStatusDetails();
      }
      this.showCheck = false;
      this.showCheckComments = false
    },
    updateSelectedAssetID () {
          if (this.destination_page !== 1) {
              this.destination_page = 1;
          }else{
              this.getStatusDetails()
          }
          this.showmenu = false
        },
        updateSelectedDeviceID () {
          if (this.destination_page !== 1) {
              this.destination_page = 1;
          }else{
              this.getStatusDetails()
          }
          this.showbeacon = false
        },
    checkAll() {
      if (!this.isCheckAll) {
        this.selctedStatus = ["TRANSIT", "LOST", "DWELL", "ACTIVE"];
      } else {
        this.selctedStatus = [];
      }
    },
    checkAllComments() {
        if (!this.isCommentsCheckAll) {
          this.selectedComments = this.commentList;
        } else {
          this.selectedComments = [];
        }
      },
      clearBeaconId() {
        this.selectedStatusDeviceID = ''
        this.getStatusDetails()
        this.showbeacon = false
      },
      clearAssetId() {
        this.selectedStatusAssetID = ''
        this.getStatusDetails()
        this.showmenu = false
      }
  },
};
</script>
<style lang="scss">
.ambt-select .theme--light.v-list {
  padding: 0;
}
.ambt-select .v-list-item {
  padding: 0 10px;
}
.label-font .v-label {
  font-size: 14px;
}
.label-font .v-input--selection-controls {
  margin-top: 0;
}
.bg-white fieldset {
  background: #fff;
}
tbody tr:nth-child(even) {
  background: #f9f9f9;
}
.cursor {
  cursor: pointer;
}
.status
  .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot {
  padding: 0 10px;
}
.all-label {
  position: absolute;
  top: 9px;
  left: 45px;
  color: rgba(0, 0, 0, 0.6);
}
.bar-graph {
  background: #fff;
  padding: 15px 20px 0px 0;
  margin-bottom: 10px;
}
.graph-header {
  padding: 0px 0px 0px 20px;
}
.graph-header i {
  border: 3px solid #256c8f;
  border-radius: 50%;
  margin-left: 7px;
  padding: 5px;
  color: #256c8f !important;
}
.graph-header .v-icon {
  font-size: 30px;
}
.graph-header p {
  color: #555;
  font-weight: 600;
  text-align: center;
}
.graph-header h1 {
  font-size: 46px;
  margin-top: -5px;
}
.status-button {
  z-index: 9999999999999;
}
.text-search .v-text-field.v-text-field--enclosed .v-text-field__details {
    display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/Status.vue